import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "./AuthContext";

const BranchContext = createContext(null);

export function BranchProvider({ children }) {
  const { user } = useAuth();
  const [branches, setBranches] = useState([]);
  const [branchId, setBranchId] = useState("br_reading");

  useEffect(() => {
    if (!user) return;
    api.get("/branches").then((r) => setBranches(r.data)).catch(() => {});
  }, [user]);

  const branch = branches.find((b) => b.id === branchId);

  return (
    <BranchContext.Provider value={{ branches, branchId, setBranchId, branch }}>
      {children}
    </BranchContext.Provider>
  );
}

export const useBranch = () => useContext(BranchContext);
